import { useEffect } from "react";

import errorImages from "common/constants/errorImages";
import { useListSearchState } from "common/hooks";
import { parseNumber } from "common/utils/numbers";

import Page from "client/common/components/layouts/Page";
import Pagination from "client/common/components/layouts/Pagination";
import Subheader from "client/common/components/layouts/Subheader";
import Body from "client/common/components/layouts/Body";
import Results from "client/common/components/results/Results";
import { useClientQuery } from "client/accounts/hooks";
import { Paths, urls } from "client/routes";

import { usePaginatedSubscriptionsQuery } from "../hooks";
import ListSubscription from "./ListSubscription";

import styles from "../styles/SubscriptionsPage.module.less";

const Subscriptions = () => {
  const [search, updateSearch] = useListSearchState<Paths["subscriptions"]["list"]>({
    page: 1,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [search.page]);

  const { data, isLoading, error } = usePaginatedSubscriptionsQuery({
    page: parseNumber(search.page, 1),
  });
  const { data: client, isLoading: isClientLoading } = useClientQuery();

  if (isLoading || isClientLoading) {
    return <Results.Loading description="Loading Autoships" />;
  }

  if (!data || error || !client) {
    return <Results.FetchError entityName="Autoships" error={error} />;
  }

  if (data.paginator.count === 0) {
    return (
      <Results.None
        image={errorImages.EmptyAutoships}
        header="You don't have any Autoships set up yet"
        dest={urls.products.search()}
        button="Search Products"
      />
    );
  }

  return (
    <div className={styles.subscriptions}>
      {data.results.map((subscription, i) => (
        <ListSubscription
          key={subscription.id}
          subscription={subscription}
          index={data.paginator.page_start_index + i - 1}
          total={data.paginator.count}
        />
      ))}
      <Pagination
        paginator={data.paginator}
        onPageChange={(page) => updateSearch({ page })}
        entityName="autoship"
      />
    </div>
  );
};

const SubscriptionsPage = () => {
  return (
    <Page>
      <Subheader
        title="My Autoships"
        description="Check the status of autoships and quickly manage schedules"
      />
      <Body>
        <Subscriptions />
      </Body>
    </Page>
  );
};

export default SubscriptionsPage;
